// globals: jQuery

import I4goIframeAbstract from './I4goFrameAbstract';

var i4goIframeDialog;

(function($) {

    i4goIframeDialog = new I4goIframeAbstract({
        formSelector: '#i4goFrameFormDialog',
        frameContainer: 'dialogForm_i4goFrame',
        i4goParamsToFormSelector: '.credit-card-form',
        frameAutoResize: false,
        template: undefined,
        cssRules: [
            "#container{padding:0px 25px 0px; overflow: auto; height: 368px;}",
            "label{margin-top:7px;font-weight:600;font-size:13px;font-family:'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif}",
            ".btn-primary{background-color: #1bbae1;border-color: #1593b3;color: #fff;background-image:none;}",
            ".btn-primary{float:right;font-size:12px;font-family:'Open Sans','Helvetica Neue',Helvetica, Arial, sans-serif;font-weight:600}",
            ".btn-primary:hover{background-color: #6ad2eb;border-color: #1bbae1;background-image:none;}",
            ".form-group:last-child{background-color: #f9fafc; padding: 15px 10px;border-top: 1px rgb(234, 237, 241) dashed;margin-left:-25px;margin-right:-25px; margin-bottom: 0px}"
        ],
        label: {
            classes:"control-label col-xs-4 text-right"
        }
    });

})(jQuery);

export default i4goIframeDialog;
